import React from 'react';
import styles from './RateCard.module.scss';
import { SFIcon, SFTextBlack, SFTextWhite } from 'sfui';
import { RateCardConfig } from '../../../../Models/Widget';
import { AppearanceContext } from 'ui-smartforce-settings';

function getIcon(inflection: number): string {
  if (inflection === -1) {
    return 'Down-7';
  } else if (inflection === 1) {
    return 'Up-7';
  } else {
    return 'equal';
  }
}

export interface RateCardProps extends RateCardConfig {}

export const RateCard = ({
  percentage,
  inflection,
  label,
  value
}: RateCardProps): React.ReactElement<RateCardProps> => {
  const { themeType } = React.useContext(AppearanceContext);
  const noData: boolean =
    label.toLocaleLowerCase() === 'no data' || value === 0;
  const displayLabel = noData ? 'No Data' : label;

  return (
    <div className={styles.rateCard}>
      <div className={styles.data}>
        {noData && <span className={styles.value}>{displayLabel}</span>}
        {!noData && (
          <>
            <span className={styles.value}>
              <SFIcon
                icon={getIcon(inflection)}
                size={24}
                color={themeType === 'day' ? SFTextBlack : SFTextWhite}
              />
              {`${Math.round(percentage)}%`}
            </span>

            <div className={styles.chip}>{displayLabel}</div>
          </>
        )}
      </div>
    </div>
  );
};
